import { useTranslation } from 'react-i18next'
import { OpenEnvelopeIcon } from './NotificationItem'

/** The prototype's `.notif-markall-btn`: the open-envelope icon button in the
 * top-bar dropdown header. Disabled while nothing is unread. */
export function MarkAllReadButton({
  unreadCount,
  onMarkAll,
}: Readonly<{ unreadCount: number; onMarkAll: () => void }>) {
  const { t } = useTranslation()
  return (
    <button
      type="button"
      onClick={onMarkAll}
      disabled={unreadCount === 0}
      aria-label={t('notifications.markAllRead')}
      title={t('notifications.markAllRead')}
      className="inline-flex items-center justify-center shrink-0 w-6 h-6 p-0 border-0 rounded-md text-[var(--accent-text)] cursor-pointer enabled:hover:bg-[var(--accent-subtle)] disabled:opacity-35 disabled:cursor-not-allowed"
    >
      <OpenEnvelopeIcon size={15} />
    </button>
  )
}
